var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12",
    staticStyle: {
      "margin-top": "-15px"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body",
    staticStyle: {
      "height": "40px"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table table-responsive-sm",
    staticStyle: {
      "margin-top": "-27px",
      "width": "75%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_c('b', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("Today's SR Closure Count :")]), _vm._v("    \n                    "), _c('u', {
    staticStyle: {
      "cursor": "pointer",
      "color": "rgb(79, 151, 39)",
      "font-size": "15px"
    },
    on: {
      "click": function($event) {
        _vm.showSRNameModal('SR Name ( Today`s Closure )', _vm.todayClosureList)
      }
    }
  }, [_c('span', {
    staticClass: "fa-stack"
  }, [_c('span', {
    staticClass: "fa fa-circle-o fa-stack-2x",
    staticStyle: {
      "font-size": "39px",
      "margin-top": "-5px"
    }
  }), _vm._v(" "), _c('strong', {
    staticClass: "fa-stack-1x",
    staticStyle: {
      "margin-left": "2px"
    }
  }, [_vm._v(_vm._s(_vm.closureCount))])])])]), _vm._v(" "), _c('td', [_c('b', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("Pending SR Closure Count :")]), _vm._v("    \n                    "), _c('u', {
    staticStyle: {
      "cursor": "pointer",
      "color": "rgb(221, 16, 16)",
      "font-size": "15px"
    },
    on: {
      "click": function($event) {
        _vm.showSRNameModal('SR Name ( Pending Closure )', _vm.pendingClosureList)
      }
    }
  }, [_c('span', {
    staticClass: "fa-stack"
  }, [_c('span', {
    staticClass: "fa fa-circle-o fa-stack-2x",
    staticStyle: {
      "font-size": "39px",
      "margin-top": "-5px"
    }
  }), _vm._v(" "), _c('strong', {
    staticClass: "fa-stack-1x",
    staticStyle: {
      "margin-left": "2px"
    }
  }, [_vm._v(_vm._s(_vm.pendingCount))])])])])])])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4",
    staticStyle: {
      "margin-top": "-15px"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('form', {
    attrs: {
      "id": "srform"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.srLoading
    },
    on: {
      "update:active": function($event) {
        _vm.srLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("SR Name "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v(" *")])], 1)]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.SR_Name),
      expression: "SR_Name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('SR_Name')
    },
    attrs: {
      "id": "SR_Name",
      "name": "SR_Name"
    },
    on: {
      "input": _vm.srChange,
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.SR_Name = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Select--")]), _vm._v(" "), _vm._l((_vm.pendingClosureList), function(SR_obj) {
    return _c('option', {
      domProps: {
        "value": SR_obj.SRID
      }
    }, [_vm._v(_vm._s(SR_obj.SRName))])
  })], 2)], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('SR_Name')),
      expression: "errors.has('SR_Name')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("SR name is required.")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("Deposit Amount "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v(" *")])], 1)]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Deposit_Amount),
      expression: "Deposit_Amount"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('Deposit_Amount')
    },
    attrs: {
      "disabled": "",
      "id": "Deposit_Amount",
      "placeholder": "Deposit Amount",
      "type": "text",
      "name": "Deposit_Amount",
      "onkeypress": "return event.charCode >= 48 && event.charCode <= 57||event.keyCode == 8"
    },
    domProps: {
      "value": (_vm.Deposit_Amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.Deposit_Amount = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('span', {
    staticClass: "text",
    staticStyle: {
      "font-size": "0.8rem",
      "color": "#5D5D5D"
    }
  }, [_vm._v("Note: For deposit amount, please enter denomination details.")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Deposit_Amount')),
      expression: "errors.has('Deposit_Amount')"
    }],
    staticClass: "text-danger",
    attrs: {
      "id": "d_a"
    }
  }, [_c('br'), _vm._v("Deposit amount is required.")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.Regionshow),
      expression: "Regionshow"
    }],
    staticClass: "multiselect"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("Reason "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v(" *")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "selectBox",
    on: {
      "click": function($event) {
        _vm.showCheckboxes()
      }
    }
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "overSelect"
  })])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "checkboxes"
    }
  }, _vm._l((_vm.ReasonList), function(Reason_obj) {
    return _c('label', {
      attrs: {
        "for": _vm.setid(Reason_obj.ReasonsID)
      }
    }, [_c('input', {
      attrs: {
        "type": "checkbox",
        "name": "reason",
        "id": _vm.setid(Reason_obj.ReasonsID)
      },
      on: {
        "change": function($event) {
          _vm.showHideReasonField(Reason_obj.ReasonsID)
        }
      }
    }), _vm._v("  " + _vm._s(Reason_obj.Reason))])
  })), _vm._v(" "), _c('span', {
    staticClass: "text",
    staticStyle: {
      "font-size": "0.8rem",
      "color": "#5D5D5D"
    }
  }, [_vm._v("Note: Please enter comma (,) seperated value in AWB Number field.")]), _vm._v(" "), (_vm.RemainData > 0) ? _c('span', {
    staticClass: "text-danger"
  }, [_c('br'), _vm._v("Note: " + _vm._s(_vm.RemainData) + " Rs is remaining amount, please select reason.")]) : _vm._e()]), _vm._v(" "), (_vm.Regionshow && _vm.cassnat) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("AWB No. "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v(" *")])], 1)]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (("" + (_vm.cassnat ? 'required' : ''))),
      expression: "`${cassnat ? 'required' : ''}`"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.cassnatAWBNo),
      expression: "cassnatAWBNo"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('cassnatAWBNo')
    },
    attrs: {
      "id": "cassnatAWBNo",
      "type": "text",
      "name": "cassnatAWBNo",
      "title": "Enter Cash/shipmet snatched by Customer AWB No.",
      "placeholder": "Cash/shipmet snatched by Customer AWB No."
    },
    domProps: {
      "value": (_vm.cassnatAWBNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cassnatAWBNo = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('cassnatAWBNo')),
      expression: "errors.has('cassnatAWBNo')"
    }],
    staticClass: "text-danger",
    attrs: {
      "id": "awb_n"
    }
  }, [_vm._v("Cash/shipmet snatched by Customer AWB No. is required.")])]) : _vm._e(), _vm._v(" "), (_vm.Regionshow && _vm.castheft) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("AWB No. "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v(" *")])], 1)]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (("" + (_vm.castheft ? 'required' : ''))),
      expression: "`${castheft ? 'required' : ''}`"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.castheftAWBNo),
      expression: "castheftAWBNo"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('castheftAWBNo')
    },
    attrs: {
      "id": "castheftAWBNo",
      "type": "text",
      "name": "castheftAWBNo",
      "title": "Enter Cash Theft by SR AWB No.",
      "placeholder": "Cash Theft by SR AWB No."
    },
    domProps: {
      "value": (_vm.castheftAWBNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.castheftAWBNo = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('castheftAWBNo')),
      expression: "errors.has('castheftAWBNo')"
    }],
    staticClass: "text-danger",
    attrs: {
      "id": "awb_n"
    }
  }, [_vm._v("Cash Theft by SR AWB No. is required.")])]) : _vm._e(), _vm._v(" "), (_vm.Regionshow && _vm.prevpenbal) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("AWB No. "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v(" *")])], 1)]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (("" + (_vm.prevpenbal ? 'required' : ''))),
      expression: "`${prevpenbal ? 'required' : ''}`"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.prevpenbalAWBNo),
      expression: "prevpenbalAWBNo"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('prevpenbalAWBNo')
    },
    attrs: {
      "id": "prevpenbalAWBNo",
      "type": "text",
      "name": "prevpenbalAWBNo",
      "title": "Enter Previous Pending Balance AWB No.",
      "placeholder": "Previous Pending Balance AWB No."
    },
    domProps: {
      "value": (_vm.prevpenbalAWBNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.prevpenbalAWBNo = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('prevpenbalAWBNo')),
      expression: "errors.has('prevpenbalAWBNo')"
    }],
    staticClass: "text-danger",
    attrs: {
      "id": "awb_n"
    }
  }, [_vm._v("Previous Pending Balance AWB No. is required.")])]) : _vm._e(), _vm._v(" "), (_vm.Regionshow && _vm.wrongdel) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("AWB No. "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v(" *")])], 1)]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (("" + (_vm.wrongdel ? 'required' : ''))),
      expression: "`${wrongdel ? 'required' : ''}`"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.wrongdelAWBNo),
      expression: "wrongdelAWBNo"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('wrongdelAWBNo')
    },
    attrs: {
      "id": "wrongdelAWBNo",
      "type": "text",
      "name": "wrongdelAWBNo",
      "title": "Enter Shpmt updation issue(Wrong Delivered/Lost Cases) AWB No.",
      "placeholder": "Shpmt updation issue(Wrong Delivered/Lost Cases) AWB No."
    },
    domProps: {
      "value": (_vm.wrongdelAWBNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.wrongdelAWBNo = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('wrongdelAWBNo')),
      expression: "errors.has('wrongdelAWBNo')"
    }],
    staticClass: "text-danger",
    attrs: {
      "id": "awb_n"
    }
  }, [_vm._v("Shpmt updation issue(Wrong Delivered/Lost Cases) AWB No. is required.")])]) : _vm._e(), _vm._v(" "), (_vm.Regionshow && _vm.sriss) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("Amount "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v(" *")])], 1)]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (("" + (_vm.sriss ? 'required' : ''))),
      expression: "`${sriss ? 'required' : ''}`"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.srtpsrAmt),
      expression: "srtpsrAmt"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('srtpsrAmt')
    },
    attrs: {
      "id": "srtpsrAmt",
      "type": "text",
      "name": "srtpsrAmt",
      "title": "Enter SR Issue (Short Payment by SR) amount",
      "placeholder": "Enter SR Issue (Short Payment by SR) amount",
      "onkeypress": "return event.charCode >= 48 && event.charCode <= 57||event.keyCode == 8"
    },
    domProps: {
      "value": (_vm.srtpsrAmt)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.srtpsrAmt = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('srtpsrAmt')),
      expression: "errors.has('srtpsrAmt')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("SR Issue (Short Payment by SR) amount is required.")])]) : _vm._e(), _vm._v(" "), (_vm.Regionshow && _vm.theftstol) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("AWB No. "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v(" *")])], 1)]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (("" + (_vm.theftstol ? 'required' : ''))),
      expression: "`${theftstol ? 'required' : ''}`"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.theftstolAWBNo),
      expression: "theftstolAWBNo"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('theftstolAWBNo')
    },
    attrs: {
      "id": "theftstolAWBNo",
      "type": "text",
      "name": "theftstolAWBNo",
      "title": "Enter Theft/Stolen cases AWB No.",
      "placeholder": "Theft/Stolen cases AWB No."
    },
    domProps: {
      "value": (_vm.theftstolAWBNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.theftstolAWBNo = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('theftstolAWBNo')),
      expression: "errors.has('theftstolAWBNo')"
    }],
    staticClass: "text-danger",
    attrs: {
      "id": "awb_n"
    }
  }, [_vm._v("Theft/Stolen cases AWB No. is required.")])]) : _vm._e(), _vm._v(" "), (_vm.Regionshow && _vm.codimpr) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("AWB No. "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v(" *")])], 1)]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (("" + (_vm.codimpr ? 'required' : ''))),
      expression: "`${codimpr ? 'required' : ''}`"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.codimprAWBNo),
      expression: "codimprAWBNo"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('codimprAWBNo')
    },
    attrs: {
      "id": "codimprAWBNo",
      "type": "text",
      "name": "codimprAWBNo",
      "title": "Enter COD used for Imprest Tax AWB No.",
      "placeholder": "COD used for Imprest Tax AWB No."
    },
    domProps: {
      "value": (_vm.codimprAWBNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.codimprAWBNo = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('codimprAWBNo')),
      expression: "errors.has('codimprAWBNo')"
    }],
    staticClass: "text-danger",
    attrs: {
      "id": "awb_n"
    }
  }, [_vm._v("COD used for Imprest Tax AWB No. is required.")])]) : _vm._e(), _vm._v(" "), (_vm.Regionshow && _vm.paychg) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("AWB No. "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v(" *")])], 1)]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (("" + (_vm.paychg ? 'required' : ''))),
      expression: "`${paychg ? 'required' : ''}`"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.paychgAWBNo),
      expression: "paychgAWBNo"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('paychgAWBNo')
    },
    attrs: {
      "id": "paychgAWBNo",
      "type": "text",
      "name": "paychgAWBNo",
      "title": "Enter Payment Mode Changed AWB No.",
      "placeholder": "Payment Mode Changed AWB No."
    },
    domProps: {
      "value": (_vm.paychgAWBNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.paychgAWBNo = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('paychgAWBNo')),
      expression: "errors.has('paychgAWBNo')"
    }],
    staticClass: "text-danger",
    attrs: {
      "id": "awb_n"
    }
  }, [_vm._v("Payment Mode Changed AWB No. is required.")])]) : _vm._e(), _vm._v(" "), (_vm.Regionshow && _vm.cariss) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("AWB No. "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v(" *")])], 1)]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (("" + (_vm.cariss ? 'required' : ''))),
      expression: "`${cariss ? 'required' : ''}`"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.carissAWBNo),
      expression: "carissAWBNo"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('carissAWBNo')
    },
    attrs: {
      "id": "carissAWBNo",
      "type": "text",
      "name": "carissAWBNo",
      "title": "Enter Card AWB number",
      "placeholder": "Card AWB No."
    },
    domProps: {
      "value": (_vm.carissAWBNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.carissAWBNo = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('carissAWBNo')),
      expression: "errors.has('carissAWBNo')"
    }],
    staticClass: "text-danger",
    attrs: {
      "id": "awb_n"
    }
  }, [_vm._v("Card AWB No. is required.")])]) : _vm._e(), _vm._v(" "), (_vm.Regionshow && _vm.selfrec) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("AWB No. "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v(" *")])], 1)]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (("" + (_vm.selfrec ? 'required' : ''))),
      expression: "`${selfrec ? 'required' : ''}`"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.selfrecAWBNo),
      expression: "selfrecAWBNo"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('selfrecAWBNo')
    },
    attrs: {
      "id": "selfrecAWBNo",
      "type": "text",
      "name": "selfrecAWBNo",
      "title": "Enter Self Debit/Client Recovery AWB No.",
      "placeholder": "Self Debit/Client Recovery AWB No."
    },
    domProps: {
      "value": (_vm.selfrecAWBNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.selfrecAWBNo = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('selfrecAWBNo')),
      expression: "errors.has('selfrecAWBNo')"
    }],
    staticClass: "text-danger",
    attrs: {
      "id": "awb_n"
    }
  }, [_vm._v("Self Debit/Client Recovery AWB No. is required.")])]) : _vm._e(), _vm._v(" "), (_vm.Regionshow && _vm.codnttim) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("AWB No. "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v(" *")])], 1)]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (("" + (_vm.codnttim ? 'required' : ''))),
      expression: "`${codnttim ? 'required' : ''}`"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.codnttimAWBNo),
      expression: "codnttimAWBNo"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('codnttimAWBNo')
    },
    attrs: {
      "id": "codnttimAWBNo",
      "type": "text",
      "name": "codnttimAWBNo",
      "title": "Enter COD not closed in time AWB No.",
      "placeholder": "COD not closed in time AWB No."
    },
    domProps: {
      "value": (_vm.codnttimAWBNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.codnttimAWBNo = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('codnttimAWBNo')),
      expression: "errors.has('codnttimAWBNo')"
    }],
    staticClass: "text-danger",
    attrs: {
      "id": "awb_n"
    }
  }, [_vm._v("COD not closed in time AWB No. is required.")])]) : _vm._e(), _vm._v(" "), (_vm.Regionshow && _vm.srabsc) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("AWB No. "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v(" *")])], 1)]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (("" + (_vm.srabsc ? 'required' : ''))),
      expression: "`${srabsc ? 'required' : ''}`"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.srabscAWBNo),
      expression: "srabscAWBNo"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('srabscAWBNo')
    },
    attrs: {
      "id": "srabscAWBNo",
      "type": "text",
      "name": "srabscAWBNo",
      "title": "Enter SR absconding AWB No.",
      "placeholder": "SR absconding AWB No."
    },
    domProps: {
      "value": (_vm.srabscAWBNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.srabscAWBNo = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('srabscAWBNo')),
      expression: "errors.has('srabscAWBNo')"
    }],
    staticClass: "text-danger",
    attrs: {
      "id": "awb_n"
    }
  }, [_vm._v("SR absconding AWB No. is required.")])]) : _vm._e(), _vm._v(" "), (_vm.Regionshow && _vm.nddiss) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("AWB No. "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v(" *")])], 1)]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (("" + (_vm.nddiss ? 'required' : ''))),
      expression: "`${nddiss ? 'required' : ''}`"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.nddissAWBNo),
      expression: "nddissAWBNo"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('nddissAWBNo')
    },
    attrs: {
      "id": "nddissAWBNo",
      "type": "text",
      "name": "nddissAWBNo",
      "title": "Enter Non-Delivery dispute AWB number",
      "placeholder": "Non-Delivery dispute AWB No."
    },
    domProps: {
      "value": (_vm.nddissAWBNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nddissAWBNo = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('nddissAWBNo')),
      expression: "errors.has('nddissAWBNo')"
    }],
    staticClass: "text-danger",
    attrs: {
      "id": "awb_n"
    }
  }, [_vm._v("Non-Delivery dispute AWB No. is required.")])]) : _vm._e(), _vm._v(" "), (_vm.Regionshow && _vm.waliss) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("AWB No. "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v(" *")])], 1)]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (("" + (_vm.waliss ? 'required' : ''))),
      expression: "`${waliss ? 'required' : ''}`"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.walissAWBNo),
      expression: "walissAWBNo"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('walissAWBNo')
    },
    attrs: {
      "id": "walissAWBNo",
      "type": "text",
      "name": "walissAWBNo",
      "title": "Enter Wallet AWB number",
      "placeholder": "Wallet AWB No."
    },
    domProps: {
      "value": (_vm.walissAWBNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.walissAWBNo = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('walissAWBNo')),
      expression: "errors.has('walissAWBNo')"
    }],
    staticClass: "text-danger",
    attrs: {
      "id": "awb_n"
    }
  }, [_vm._v("Wallet AWB No. is required.")])]) : _vm._e(), _vm._v(" "), (_vm.Regionshow && _vm.paypiss) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("AWB No. "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v(" *")])], 1)]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (("" + (_vm.paypiss ? 'required' : ''))),
      expression: "`${paypiss ? 'required' : ''}`"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.paypissAWBNo),
      expression: "paypissAWBNo"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('paypissAWBNo')
    },
    attrs: {
      "id": "paypissAWBNo",
      "type": "text",
      "name": "paypissAWBNo",
      "title": "Enter Payphi AWB number",
      "placeholder": "Payphi AWB No."
    },
    domProps: {
      "value": (_vm.paypissAWBNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.paypissAWBNo = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('paypissAWBNo')),
      expression: "errors.has('paypissAWBNo')"
    }],
    staticClass: "text-danger",
    attrs: {
      "id": "awb_n"
    }
  }, [_vm._v("Payphi AWB No. is required.")])]) : _vm._e(), _vm._v(" "), (_vm.Regionshow && _vm.raziss) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("AWB No. "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v(" *")])], 1)]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (("" + (_vm.raziss ? 'required' : ''))),
      expression: "`${raziss ? 'required' : ''}`"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.razissAWBNo),
      expression: "razissAWBNo"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('razissAWBNo')
    },
    attrs: {
      "id": "razissAWBNo",
      "type": "text",
      "name": "razissAWBNo",
      "title": "Enter Razorpay AWB number",
      "placeholder": "Razorpay AWB No."
    },
    domProps: {
      "value": (_vm.razissAWBNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.razissAWBNo = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('razissAWBNo')),
      expression: "errors.has('razissAWBNo')"
    }],
    staticClass: "text-danger",
    attrs: {
      "id": "awb_n"
    }
  }, [_vm._v("Razorpay AWB No. is required.")])]) : _vm._e(), _vm._v(" "), (_vm.Regionshow && _vm.pine) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("AWB No. "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v(" *")])], 1)]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (("" + (_vm.pine ? 'required' : ''))),
      expression: "`${pine ? 'required' : ''}`"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.pineAWBNo),
      expression: "pineAWBNo"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('pineAWBNo')
    },
    attrs: {
      "id": "pineAWBNo",
      "type": "text",
      "name": "pineAWBNo",
      "title": "Enter Pinelab AWB number",
      "placeholder": "Pinelab AWB No."
    },
    domProps: {
      "value": (_vm.pineAWBNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pineAWBNo = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('pineAWBNo')),
      expression: "errors.has('pineAWBNo')"
    }],
    staticClass: "text-danger",
    attrs: {
      "id": "awb_n"
    }
  }, [_vm._v("Pinelab AWB No. is required.")])]) : _vm._e(), _vm._v(" "), (_vm.Regionshow && _vm.habridpi) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("AWB No. "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v(" *")])], 1)]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (("" + (_vm.habridpi ? 'required' : ''))),
      expression: "`${habridpi ? 'required' : ''}`"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.habridpiAWBNo),
      expression: "habridpiAWBNo"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('habridpiAWBNo')
    },
    attrs: {
      "id": "habridpiAWBNo",
      "type": "text",
      "name": "habridpiAWBNo",
      "title": "Enter Hybrid AWB number",
      "placeholder": "Enter Hybrid AWB"
    },
    domProps: {
      "value": (_vm.habridpiAWBNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.habridpiAWBNo = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('habridpiAWBNo')),
      expression: "errors.has('habridpiAWBNo')"
    }],
    staticClass: "text-danger",
    attrs: {
      "id": "awb_n"
    }
  }, [_vm._v("Hybrid AWB No. is required.")])]) : _vm._e(), _vm._v(" "), (_vm.Regionshow && _vm.habridpi) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("Amount "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v(" *")])], 1)]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (("" + (_vm.habridpi ? 'required' : ''))),
      expression: "`${habridpi ? 'required' : ''}`"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.habridpiAMT),
      expression: "habridpiAMT"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('habridpiAMT')
    },
    attrs: {
      "id": "habridpiAMT",
      "type": "text",
      "name": "habridpiAMT",
      "title": "Enter Hybrid Dispute Amount",
      "placeholder": "Enter Hybrid Dispute Amount",
      "onkeypress": "return event.charCode >= 48 && event.charCode <= 57||event.keyCode == 8"
    },
    domProps: {
      "value": (_vm.habridpiAMT)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.habridpiAMT = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('habridpiAMT')),
      expression: "errors.has('habridpiAMT')"
    }],
    staticClass: "text-danger",
    attrs: {
      "id": "awb_n"
    }
  }, [_vm._v("Amount is required.")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.subLoading
    },
    on: {
      "update:active": function($event) {
        _vm.subLoading = $event
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "disabled": _vm.disableButton,
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-dot-circle-o"
  }), _vm._v(" Submit")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-danger",
    attrs: {
      "disabled": _vm.disableButton,
      "type": "reset"
    },
    on: {
      "click": _vm.resetData
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Clear")])], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4",
    staticStyle: {
      "margin-top": "-15px"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "fa fa-align-justify"
  }), _vm._v(" Denomination "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v(" *")])], 1), _vm._v(" "), _c('div', {
    staticClass: "card-body",
    staticStyle: {
      "height": "500px"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.denomLoading
    },
    on: {
      "update:active": function($event) {
        _vm.denomLoading = $event
      }
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table table-responsive-sm",
    attrs: {
      "height": "10"
    }
  }, [_vm._m(4), _vm._v(" "), _c('tbody', [_vm._l((_vm.DenominationList), function(data) {
    return _c('tr', [_c('td', {
      staticClass: "notes"
    }, [_vm._v(_vm._s(data.Denomination))]), _vm._v(" "), _c('td', {
      staticClass: "notes"
    }, [_c('input', {
      staticClass: "form-control",
      attrs: {
        "id": ("" + (data.Denomination)),
        "name": "`${data.Denomination}`",
        "min": "0",
        "type": "number",
        "onkeypress": "return event.charCode >= 48 && event.charCode <= 57||event.keyCode == 8"
      },
      on: {
        "change": _vm.notesCount
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "notes"
    }, [_c('input', {
      staticClass: "form-control",
      attrs: {
        "id": ("mo" + (data.Denomination)),
        "type": "text",
        "name": "note_amt",
        "value": "0",
        "disabled": ""
      }
    }), _vm._v(" "), _c('input', {
      staticClass: "form-control",
      attrs: {
        "id": ("moi" + (data.Denomination)),
        "type": "hidden",
        "disabled": ""
      },
      domProps: {
        "value": ("" + (data.DenominationID))
      }
    })])])
  }), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "notes"
  }), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('td', {
    staticClass: "notes"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tot_amt),
      expression: "tot_amt"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "tot_amt",
      "type": "text",
      "name": "tot_amt",
      "value": "0",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.tot_amt)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.tot_amt = $event.target.value
      }
    }
  })])])], 2)])], 1)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.RightSRLedger),
      expression: "RightSRLedger"
    }],
    staticClass: "col-sm-4",
    staticStyle: {
      "margin-top": "-15px"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.Loading
    },
    on: {
      "update:active": function($event) {
        _vm.Loading = $event
      }
    }
  }), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.Loading
    },
    on: {
      "update:active": function($event) {
        _vm.Loading = $event
      }
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table-responsive-sm table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._m(7), _vm._v(" "), _c('tbody', [_c('tr', [(_vm.assign > 0) ? _c('td', {
    staticClass: "text-center",
    staticStyle: {
      "cursor": "pointer",
      "color": "rgb(25,25,112)"
    },
    on: {
      "click": function($event) {
        _vm.showShippingidModal('Assign AWB Numbers', _vm.assignArr)
      }
    }
  }, [_c('u', [_vm._v(_vm._s(_vm.assign))])]) : _vm._e(), _vm._v(" "), (_vm.assign <= 0) ? _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.assign))]) : _vm._e(), _vm._v(" "), (_vm.prepaid > 0) ? _c('td', {
    staticClass: "text-center",
    staticStyle: {
      "cursor": "pointer",
      "color": "rgb(25,25,112)"
    },
    on: {
      "click": function($event) {
        _vm.showShippingidModal('Prepaid AWB Numbers', _vm.prepaidArr)
      }
    }
  }, [_c('u', [_vm._v(_vm._s(_vm.prepaid))])]) : _vm._e(), _vm._v(" "), (_vm.prepaid <= 0) ? _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.prepaid))]) : _vm._e(), _vm._v(" "), (_vm.cod > 0) ? _c('td', {
    staticClass: "text-center",
    staticStyle: {
      "cursor": "pointer",
      "color": "rgb(25,25,112)"
    },
    on: {
      "click": function($event) {
        _vm.showShippingidModal('COD AWB Numbers', _vm.codArr)
      }
    }
  }, [_c('u', [_vm._v(_vm._s(_vm.cod))])]) : _vm._e(), _vm._v(" "), (_vm.cod <= 0) ? _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.cod))]) : _vm._e()])])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.Loading
    },
    on: {
      "update:active": function($event) {
        _vm.Loading = $event
      }
    }
  }), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table-responsive-sm table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._m(9), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "text-center",
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("Cash")]), _vm._v(" "), (_vm.TodaysCashCount > 0) ? _c('td', {
    staticClass: "text-center",
    staticStyle: {
      "width": "30%",
      "cursor": "pointer",
      "color": "rgb(25,25,112)",
      "text-decoration": "underline"
    },
    on: {
      "click": function($event) {
        _vm.showShippingidModal('Cash AWB Numbers', _vm.deliveredCashArr)
      }
    }
  }, [_vm._v(_vm._s(_vm.TodaysCashCount))]) : _vm._e(), _vm._v(" "), (_vm.TodaysCashCount <= 0) ? _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.TodaysCashCount))]) : _vm._e(), _vm._v(" "), (_vm.hybridCashArr.length > 0) ? _c('td', {
    staticClass: "text-center",
    staticStyle: {
      "width": "30%",
      "cursor": "pointer",
      "color": "rgb(25,25,112)",
      "text-decoration": "underline"
    },
    on: {
      "click": function($event) {
        _vm.showShippingidModal('Cash AWB Numbers', _vm.hybridCashArr, 'hybrid')
      }
    }
  }, [_vm._v(_vm._s(_vm.hybridCashArr.length))]) : _vm._e(), _vm._v(" "), (_vm.hybridCashArr.length <= 0) ? _c('td', {
    staticClass: "text-center"
  }, [_vm._v("0")]) : _vm._e(), _vm._v(" "), _c('td', {
    staticClass: "text-center",
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.TodaysCash))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-center",
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("Payphi")]), _vm._v(" "), (_vm.TodaysPayphiCount > 0) ? _c('td', {
    staticClass: "text-center",
    staticStyle: {
      "width": "30%",
      "cursor": "pointer",
      "color": "rgb(25,25,112)",
      "text-decoration": "underline"
    },
    on: {
      "click": function($event) {
        _vm.showShippingidModal('Payphi AWB Numbers', _vm.deliveredPayphiArr)
      }
    }
  }, [_vm._v(_vm._s(_vm.TodaysPayphiCount))]) : _vm._e(), _vm._v(" "), (_vm.TodaysPayphiCount <= 0) ? _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.TodaysPayphiCount))]) : _vm._e(), _vm._v(" "), (_vm.hybridPayphiArr.length > 0) ? _c('td', {
    staticClass: "text-center",
    staticStyle: {
      "width": "30%",
      "cursor": "pointer",
      "color": "rgb(25,25,112)",
      "text-decoration": "underline"
    },
    on: {
      "click": function($event) {
        _vm.showShippingidModal('Payphi AWB Numbers', _vm.hybridPayphiArr, 'hybrid')
      }
    }
  }, [_vm._v(_vm._s(_vm.hybridPayphiArr.length))]) : _vm._e(), _vm._v(" "), (_vm.hybridPayphiArr.length <= 0) ? _c('td', {
    staticClass: "text-center"
  }, [_vm._v("0")]) : _vm._e(), _vm._v(" "), _c('td', {
    staticClass: "text-center",
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.TodaysPayphi))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-center",
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("Card")]), _vm._v(" "), (_vm.TodaysCardCount > 0) ? _c('td', {
    staticClass: "text-center",
    staticStyle: {
      "width": "30%",
      "cursor": "pointer",
      "color": "rgb(25,25,112)",
      "text-decoration": "underline"
    },
    on: {
      "click": function($event) {
        _vm.showShippingidModal('Card AWB Numbers', _vm.deliveredCardArr)
      }
    }
  }, [_vm._v(_vm._s(_vm.TodaysCardCount))]) : _vm._e(), _vm._v(" "), (_vm.TodaysCardCount <= 0) ? _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.TodaysCardCount))]) : _vm._e(), _vm._v(" "), (_vm.hybridCardArr.length > 0) ? _c('td', {
    staticClass: "text-center",
    staticStyle: {
      "width": "30%",
      "cursor": "pointer",
      "color": "rgb(25,25,112)",
      "text-decoration": "underline"
    },
    on: {
      "click": function($event) {
        _vm.showShippingidModal('Card AWB Numbers', _vm.hybridCardArr, 'hybrid')
      }
    }
  }, [_vm._v(_vm._s(_vm.hybridCardArr.length))]) : _vm._e(), _vm._v(" "), (_vm.hybridCardArr.length <= 0) ? _c('td', {
    staticClass: "text-center"
  }, [_vm._v("0")]) : _vm._e(), _vm._v(" "), _c('td', {
    staticClass: "text-center",
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.TodaysCard))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-center",
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("Wallet")]), _vm._v(" "), (_vm.TodaysWalletCount > 0) ? _c('td', {
    staticClass: "text-center",
    staticStyle: {
      "width": "30%",
      "cursor": "pointer",
      "color": "rgb(25,25,112)",
      "text-decoration": "underline"
    },
    on: {
      "click": function($event) {
        _vm.showShippingidModal('Wallet AWB Numbers', _vm.deliveredWalletArr)
      }
    }
  }, [_vm._v(_vm._s(_vm.TodaysWalletCount))]) : _vm._e(), _vm._v(" "), (_vm.TodaysWalletCount <= 0) ? _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.TodaysWalletCount))]) : _vm._e(), _vm._v(" "), (_vm.hybridWalletArr.length > 0) ? _c('td', {
    staticClass: "text-center",
    staticStyle: {
      "width": "30%",
      "cursor": "pointer",
      "color": "rgb(25,25,112)",
      "text-decoration": "underline"
    },
    on: {
      "click": function($event) {
        _vm.showShippingidModal('Wallet AWB Numbers', _vm.hybridWalletArr, 'hybrid')
      }
    }
  }, [_vm._v(_vm._s(_vm.hybridWalletArr.length))]) : _vm._e(), _vm._v(" "), (_vm.hybridWalletArr.length <= 0) ? _c('td', {
    staticClass: "text-center"
  }, [_vm._v("0")]) : _vm._e(), _vm._v(" "), _c('td', {
    staticClass: "text-center",
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.TodaysWallet))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-center",
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("Razorpay")]), _vm._v(" "), (_vm.TodaysRazorpayCount > 0) ? _c('td', {
    staticClass: "text-center",
    staticStyle: {
      "width": "30%",
      "cursor": "pointer",
      "color": "rgb(25,25,112)",
      "text-decoration": "underline"
    },
    on: {
      "click": function($event) {
        _vm.showShippingidModal('Razorpay AWB Numbers', _vm.deliveredRazorpayArr)
      }
    }
  }, [_vm._v(_vm._s(_vm.TodaysRazorpayCount))]) : _vm._e(), _vm._v(" "), (_vm.TodaysRazorpayCount <= 0) ? _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.TodaysRazorpayCount))]) : _vm._e(), _vm._v(" "), (_vm.hybridRazorpayArr.length > 0) ? _c('td', {
    staticClass: "text-center",
    staticStyle: {
      "width": "30%",
      "cursor": "pointer",
      "color": "rgb(25,25,112)",
      "text-decoration": "underline"
    },
    on: {
      "click": function($event) {
        _vm.showShippingidModal('Razorpay AWB Numbers', _vm.hybridRazorpayArr, 'hybrid')
      }
    }
  }, [_vm._v(_vm._s(_vm.hybridRazorpayArr.length))]) : _vm._e(), _vm._v(" "), (_vm.hybridRazorpayArr.length <= 0) ? _c('td', {
    staticClass: "text-center"
  }, [_vm._v("0")]) : _vm._e(), _vm._v(" "), _c('td', {
    staticClass: "text-center",
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.TodaysRazorpay))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-center",
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("Pinelab")]), _vm._v(" "), (_vm.TodaysPineLabCount > 0) ? _c('td', {
    staticClass: "text-center",
    staticStyle: {
      "width": "30%",
      "cursor": "pointer",
      "color": "rgb(25,25,112)",
      "text-decoration": "underline"
    },
    on: {
      "click": function($event) {
        _vm.showShippingidModal('Pinelab AWB Numbers', _vm.deliveredPinelabArr)
      }
    }
  }, [_vm._v(_vm._s(_vm.TodaysPineLabCount))]) : _vm._e(), _vm._v(" "), (_vm.TodaysPineLabCount <= 0) ? _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.TodaysPineLabCount))]) : _vm._e(), _vm._v(" "), (_vm.hybridPinelabArr.length > 0) ? _c('td', {
    staticClass: "text-center",
    staticStyle: {
      "width": "30%",
      "cursor": "pointer",
      "color": "rgb(25,25,112)",
      "text-decoration": "underline"
    },
    on: {
      "click": function($event) {
        _vm.showShippingidModal('Pinelab AWB Numbers', _vm.hybridPinelabArr, 'hybrid')
      }
    }
  }, [_vm._v(_vm._s(_vm.hybridPinelabArr.length))]) : _vm._e(), _vm._v(" "), (_vm.hybridPinelabArr.length <= 0) ? _c('td', {
    staticClass: "text-center"
  }, [_vm._v("0")]) : _vm._e(), _vm._v(" "), _c('td', {
    staticClass: "text-center",
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.TodaysPineLab))])])])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.Loading
    },
    on: {
      "update:active": function($event) {
        _vm.Loading = $event
      }
    }
  }), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table table-responsive-sm"
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("Today's COD Amount")]), _vm._v(" "), _c('td', [_c('i', {
    staticClass: "fa fa-rupee"
  }), _vm._v(" " + _vm._s(_vm.TodaysCOD))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Pending COD Amount")]), _vm._v(" "), _c('td', [_c('i', {
    staticClass: "fa fa-rupee"
  }), _vm._v(" " + _vm._s(_vm.PendingCOD))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Total Amount")]), _vm._v(" "), _c('td', {
    attrs: {
      "id": "Tot_Amt"
    }
  }, [_c('i', {
    staticClass: "fa fa-rupee"
  }), _vm._v(" " + _vm._s(_vm.TotalAmount))])])])])], 1)], 1)]), _vm._v(" "), _c('b-modal', {
    ref: "shippingModalRef",
    attrs: {
      "id": "#confirmationmodal1",
      "title": "Confirmation"
    },
    model: {
      value: (_vm.modalShippingShow),
      callback: function($$v) {
        _vm.modalShippingShow = $$v
      },
      expression: "modalShippingShow"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h5', {
    staticClass: "modal-title",
    staticStyle: {
      "font-size": "1rem"
    }
  }, [_vm._v(_vm._s(_vm.awbnotype) + ":")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeShippingidModal
    }
  }, [_c('span', {
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [(_vm.awbArr.length > 10) ? _c('table', {
    staticClass: "table-bordered table-hover tbl datatables scroll",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "25px"
    }
  }, [_c('b', [_vm._v("#")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "298px"
    }
  }, [_c('b', [_vm._v("AWB Number")])]), _vm._v(" "), (!_vm.hyb) ? _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "128px"
    }
  }, [_c('b', [_vm._v("Amount ( "), _c('i', {
    staticClass: "fa fa-rupee"
  }), _vm._v(" )")])]) : _vm._e(), _vm._v(" "), (_vm.hyb) ? _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "128px"
    }
  }, [_c('b', [_vm._v("Cash ( "), _c('i', {
    staticClass: "fa fa-rupee"
  }), _vm._v(" )")])]) : _vm._e(), _vm._v(" "), (_vm.hyb) ? _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "128px"
    }
  }, [_c('b', [_vm._v("Digital ( "), _c('i', {
    staticClass: "fa fa-rupee"
  }), _vm._v(" )")])]) : _vm._e()])]), _vm._v(" "), _c('tbody', _vm._l((_vm.awbArr), function(val, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), (!_vm.hyb) ? _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "70%"
      }
    }, [_vm._v(_vm._s(val.ShippingID))]) : _vm._e(), _vm._v(" "), (!_vm.hyb) ? _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "30%"
      }
    }, [_vm._v(_vm._s(val.Amount))]) : _vm._e(), _vm._v(" "), (_vm.hyb) ? _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "60%"
      }
    }, [_vm._v(_vm._s(val.ShippingID))]) : _vm._e(), _vm._v(" "), (_vm.hyb) ? _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "20%"
      }
    }, [_vm._v(_vm._s(val.cashAmt))]) : _vm._e(), _vm._v(" "), (_vm.hyb) ? _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "20%"
      }
    }, [_vm._v(_vm._s(val.digitalAmt))]) : _vm._e()])
  }))]) : _vm._e(), _vm._v(" "), (_vm.awbArr.length < 11) ? _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "18px"
    }
  }, [_c('b', [_vm._v("#")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "312px"
    }
  }, [_c('b', [_vm._v("AWB Number")])]), _vm._v(" "), (!_vm.hyb) ? _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "133px"
    }
  }, [_c('b', [_vm._v("Amount ( "), _c('i', {
    staticClass: "fa fa-rupee"
  }), _vm._v(" )")])]) : _vm._e(), _vm._v(" "), (_vm.hyb) ? _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "128px"
    }
  }, [_c('b', [_vm._v("Cash ( "), _c('i', {
    staticClass: "fa fa-rupee"
  }), _vm._v(" )")])]) : _vm._e(), _vm._v(" "), (_vm.hyb) ? _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "128px"
    }
  }, [_c('b', [_vm._v("Digital ( "), _c('i', {
    staticClass: "fa fa-rupee"
  }), _vm._v(" )")])]) : _vm._e()])]), _vm._v(" "), _c('tbody', [(_vm.awbArr.length <= 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "3",
      "align": "center"
    }
  }, [_vm._v("No record found")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.awbArr), function(val, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), (!_vm.hyb) ? _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "70%"
      }
    }, [_vm._v(_vm._s(val.ShippingID))]) : _vm._e(), _vm._v(" "), (!_vm.hyb) ? _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "30%"
      }
    }, [_vm._v(_vm._s(val.Amount))]) : _vm._e(), _vm._v(" "), (_vm.hyb) ? _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "60%"
      }
    }, [_vm._v(_vm._s(val.ShippingID))]) : _vm._e(), _vm._v(" "), (_vm.hyb) ? _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "20%"
      }
    }, [_vm._v(_vm._s(val.cashAmt))]) : _vm._e(), _vm._v(" "), (_vm.hyb) ? _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "20%"
      }
    }, [_vm._v(_vm._s(val.digitalAmt))]) : _vm._e()])
  })], 2)]) : _vm._e()])])])]), _vm._v(" "), _c('b-modal', {
    ref: "SRNameModalRef",
    attrs: {
      "id": "#confirmationmodal3",
      "title": "Confirmation"
    },
    model: {
      value: (_vm.modalSRNameShow),
      callback: function($$v) {
        _vm.modalSRNameShow = $$v
      },
      expression: "modalSRNameShow"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h5', {
    staticClass: "modal-title",
    staticStyle: {
      "font-size": "1rem"
    }
  }, [_vm._v(_vm._s(_vm.srtype) + ":")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeSRNameModal
    }
  }, [_c('span', {
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [(_vm.srArr.length > 10) ? _c('table', {
    staticClass: "table-bordered table-hover tbl datatables scroll",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "135px"
    }
  }, [_c('b', [_vm._v("#")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "315px"
    }
  }, [_c('b', [_vm._v("SR Name")])])])]), _vm._v(" "), _c('tbody', [(_vm.srArr.length <= 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "3",
      "align": "center"
    }
  }, [_vm._v("No record found")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.srArr), function(val, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "135px"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "70%"
      }
    }, [_vm._v(_vm._s(val.SRName))])])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.srArr.length < 11) ? _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "18px"
    }
  }, [_c('b', [_vm._v("#")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "312px"
    }
  }, [_c('b', [_vm._v("SR Name")])])])]), _vm._v(" "), _c('tbody', [(_vm.srArr.length <= 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "3",
      "align": "center"
    }
  }, [_vm._v("No record found")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.srArr), function(val, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "70%"
      }
    }, [_vm._v(_vm._s(val.SRName))])])
  })], 2)]) : _vm._e()])])])]), _vm._v(" "), _c('b-modal', {
    ref: "myModalRef",
    attrs: {
      "id": "#confirmationmodal",
      "title": "Confirmation"
    },
    model: {
      value: (_vm.modalShow),
      callback: function($$v) {
        _vm.modalShow = $$v
      },
      expression: "modalShow"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h5', {
    staticClass: "modal-title"
  }, [_vm._v("Confirmation")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeStatusRoleModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('h5', {
    staticStyle: {
      "font-size": "1rem",
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.RemainData) + " Rs. is remaining amount, please select reason")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm"
  }, [_c('center', [_c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "background-color": "#20a8d8"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.modalShow = false
      }
    }
  }, [_vm._v("OK")])])], 1)])])]), _vm._v(" "), _c('b-modal', {
    ref: "myConfModalRef",
    attrs: {
      "id": "#confirmationmodal",
      "title": "Confirmation"
    },
    model: {
      value: (_vm.ConfmodalShow),
      callback: function($$v) {
        _vm.ConfmodalShow = $$v
      },
      expression: "ConfmodalShow"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h5', {
    staticClass: "modal-title"
  }, [_vm._v("Confirmation")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeStatusRoleModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('h5', {
    staticStyle: {
      "font-size": "1rem",
      "color": "red"
    }
  }, [_vm._v("Are you sure to submit the SR closure.")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm"
  }, [_c('center', [_c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "background-color": "#20a8d8"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.hideConfModal('0')
      }
    }
  }, [_vm._v("Ok")])])], 1)])])]), _vm._v(" "), _c('b-modal', {
    ref: "myExModalRef",
    attrs: {
      "id": "#confirmationmodal",
      "title": "Confirmation"
    },
    model: {
      value: (_vm.ExmodalShow),
      callback: function($$v) {
        _vm.ExmodalShow = $$v
      },
      expression: "ExmodalShow"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h5', {
    staticClass: "modal-title"
  }, [_vm._v("Confirmation")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeStatusRoleModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('h5', {
    staticStyle: {
      "font-size": "1rem",
      "color": "red"
    }
  }, [_vm._v("Please make sure you have enter extra amount of Rs. " + _vm._s(_vm.ExData))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm"
  }, [_c('center', [_c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "background-color": "#20a8d8"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.hideExModal('0')
      }
    }
  }, [_vm._v("Ok")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    staticStyle: {
      "background-color": "#f86c6b"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.hideExModal('1')
      }
    }
  }, [_vm._v("Cancel")])])], 1)])])]), _vm._v(" "), _c('b-modal', {
    ref: "myCardModalRef",
    attrs: {
      "id": "#confirmationmodal2",
      "title": "Confirmation"
    },
    model: {
      value: (_vm.cardModalShow),
      callback: function($$v) {
        _vm.cardModalShow = $$v
      },
      expression: "cardModalShow"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "width": "150%"
    }
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h5', {
    staticClass: "modal-title",
    staticStyle: {
      "font-size": "1rem"
    }
  }, [_vm._v("AWB No & AWB Amount Confirmation")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeStatusRoleModal
    }
  }, [_c('span', {
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "1%"
    }
  }, [_c('b', [_vm._v("#")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "50%"
    }
  }, [_c('b', [_vm._v("Reason")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "49%"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables"
  }, [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "25%"
    }
  }, [_c('b', [_vm._v("AWB Number")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "10%"
    }
  }, [_c('b', [_vm._v("Amount ( "), _c('i', {
    staticClass: "fa fa-rupee"
  }), _vm._v(" )")])])])])])])]), _vm._v(" "), _c('tbody', [(_vm.DisputeArr.length <= 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "3",
      "align": "center"
    }
  }, [_vm._v("No record found")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.DisputeArr), function(val, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "1%"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "50%"
      }
    }, [_vm._v(_vm._s(val.Reason))]), _vm._v(" "), (val.ReasonAmt) ? _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "49%"
      }
    }, [_c('table', {
      staticClass: "table-bordered table-hover tbl datatables"
    }, [_c('tr', [_c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "20%"
      }
    }, [_vm._v("\n                              " + _vm._s(val.awb.map(function (x) { return Object.keys(x)[0]; }).join(', ')) + "\n                          ")]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "9%"
      }
    }, [_vm._v(_vm._s(val.ReasonAmt))])])])]) : _vm._e(), _vm._v(" "), (!val.ReasonAmt) ? _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "49%"
      }
    }, [_c('table', {
      staticClass: "table-bordered table-hover tbl datatables"
    }, _vm._l((val.awb), function(row, ind) {
      return _c('tr', [_c('td', {
        staticClass: "text-center",
        staticStyle: {
          "width": "21%"
        }
      }, [_vm._v(_vm._s((Object.keys(row)) ? Object.keys(row).toString() : ''))]), _vm._v(" "), _c('td', {
        staticClass: "text-center",
        staticStyle: {
          "width": "9%"
        }
      }, [_vm._v(_vm._s((Object.values(row)) ? Object.values(row).toString() : ''))])])
    }))]) : _vm._e()])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm"
  }, [_c('center', [_c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "background-color": "#20a8d8"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.hideCardModal('0')
      }
    }
  }, [_vm._v("Ok")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    staticStyle: {
      "background-color": "#f86c6b"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.hideCardModal('1')
      }
    }
  }, [_vm._v("Cancel")])])], 1)])])]), _vm._v(" "), _c('b-modal', {
    ref: "myReasonModalRef",
    attrs: {
      "id": "#confirmationmodal3",
      "title": "Confirmation"
    },
    model: {
      value: (_vm.ReasonModalShow),
      callback: function($$v) {
        _vm.ReasonModalShow = $$v
      },
      expression: "ReasonModalShow"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "width": "150%"
    }
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h5', {
    staticClass: "modal-title",
    staticStyle: {
      "font-size": "1rem"
    }
  }, [_vm._v("Dispute Reason & AWB No/Amount")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeStatusRoleModal
    }
  }, [_c('span', {
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "1%"
    }
  }, [_c('b', [_vm._v("#")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "50%"
    }
  }, [_c('b', [_vm._v("Reason")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "49%"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables"
  }, [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "25%"
    }
  }, [_c('b', [_vm._v("AWB Number")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "10%"
    }
  }, [_c('b', [_vm._v("Amount ( "), _c('i', {
    staticClass: "fa fa-rupee"
  }), _vm._v(" )")])])])])])])]), _vm._v(" "), _c('tbody', [(_vm.DisputeArr.length <= 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "3",
      "align": "center"
    }
  }, [_vm._v("No record found")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.DisputeArr), function(val, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "1%"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "50%"
      }
    }, [_vm._v(_vm._s(val.Reason))]), _vm._v(" "), (val.ReasonAmt) ? _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "49%"
      }
    }, [_c('table', {
      staticClass: "table-bordered table-hover tbl datatables"
    }, [_c('tr', [_c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "21%"
      }
    }, [_vm._v(_vm._s(val.awb.map(function (x) { return Object.keys(x)[0]; }).join(', ')))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "9%"
      }
    }, [_vm._v(_vm._s(val.ReasonAmt))])])])]) : _vm._e(), _vm._v(" "), (!val.ReasonAmt) ? _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "49%"
      }
    }, [_c('table', {
      staticClass: "table-bordered table-hover tbl datatables"
    }, _vm._l((val.awb), function(row, ind) {
      return _c('tr', [_c('td', {
        staticClass: "text-center",
        staticStyle: {
          "width": "21%"
        }
      }, [_vm._v(_vm._s((Object.keys(row)) ? Object.keys(row).toString() : ''))]), _vm._v(" "), _c('td', {
        staticClass: "text-center",
        staticStyle: {
          "width": "9%"
        }
      }, [_vm._v(_vm._s((Object.values(row)) ? Object.values(row).toString() : ''))])])
    }))]) : _vm._e()])
  })], 2)])])])])]), _vm._v(" "), _c('b-modal', {
    ref: "myDenomDetailModalRef",
    attrs: {
      "id": "#confirmationmodal4",
      "title": "Confirmation"
    },
    model: {
      value: (_vm.DenomDetailModalShow),
      callback: function($$v) {
        _vm.DenomDetailModalShow = $$v
      },
      expression: "DenomDetailModalShow"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "width": "150%"
    }
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h5', {
    staticClass: "modal-title",
    staticStyle: {
      "font-size": "1rem"
    }
  }, [_vm._v("Denomination Detail")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeStatusRoleModal
    }
  }, [_c('span', {
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "30%"
    }
  }, [_c('b', [_vm._v("Denomination")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "30%"
    }
  }, [_c('b', [_vm._v("Note Count")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "30%"
    }
  }, [_c('b', [_vm._v("Amount ( "), _c('i', {
    staticClass: "fa fa-rupee"
  }), _vm._v(" )")])])])]), _vm._v(" "), _c('tbody', [(_vm.DenomDetail.length <= 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "3",
      "align": "center"
    }
  }, [_vm._v("No record found")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.DenomDetail), function(val, index) {
    return (val.NoteCount > 0) ? _c('tr', [_c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "30%"
      }
    }, [_vm._v(_vm._s(val.Denomination))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "30%"
      }
    }, [_vm._v(_vm._s(val.NoteCount))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "30%"
      }
    }, [_vm._v(_vm._s(val.Denomination * val.NoteCount))])]) : _vm._e()
  })], 2)])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.SRLedgerDetails),
      expression: "SRLedgerDetails"
    }],
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-headerfrm",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_vm._m(11), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.ledgerLoading
    },
    on: {
      "update:active": function($event) {
        _vm.ledgerLoading = $event
      }
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._m(12), _vm._v(" "), _c('tbody', [(_vm.resultCount == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "7",
      "align": "center"
    }
  }, [_vm._v("No record found")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.SRLedgerList), function(SL_List, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_c('strong', [_vm._v(_vm._s(index + 1))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(SL_List.deliverydate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(SL_List.codamount))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(SL_List.creditamount != 0) ? _c('span', {
      staticStyle: {
        "cursor": "pointer",
        "color": "rgb(25,25,112)",
        "text-decoration": "underline"
      },
      on: {
        "click": function($event) {
          _vm.showDenomDetail(SL_List.denomination)
        }
      }
    }, [_vm._v(_vm._s(SL_List.creditamount))]) : _vm._e(), _vm._v(" "), (SL_List.creditamount == 0) ? _c('span', [_vm._v(_vm._s(SL_List.creditamount))]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(SL_List.awbno) ? _c('span', {
      staticStyle: {
        "cursor": "pointer",
        "color": "rgb(25,25,112)",
        "text-decoration": "underline"
      },
      on: {
        "click": function($event) {
          _vm.showReasonAWBNo(SL_List.awbno)
        }
      }
    }, [_vm._v(_vm._s(SL_List.debitamount))]) : _vm._e(), _vm._v(" "), (SL_List.awbno == null) ? _c('span', [_vm._v(_vm._s(SL_List.debitamount))]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(SL_List.createddate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(SL_List.createdby))])])
  })], 2)]), _c('br')], 1)])], 1)])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "fa fa-align-justify"
  }), _vm._v(" COD SR Day Closure")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-append"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_c('i', {
    staticClass: "fa fa-rupee"
  })])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('select', [_c('option', [_vm._v("-- Select Reason --")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-append"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_c('i', {
    staticClass: "fa fa-rupee"
  })])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Notes")]), _vm._v(" "), _c('th', [_vm._v("Count")]), _vm._v(" "), _c('th', [_vm._v("Amount")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "notes"
  }, [_c('strong', [_vm._v("Total")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "fa fa-align-justify"
  }), _vm._v("Today's Shipment - Count")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "30%"
    }
  }, [_c('b', [_vm._v("Assign")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "30%"
    }
  }, [_c('b', [_vm._v("Prepaid")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "30%"
    }
  }, [_c('b', [_vm._v("COD")])])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "fa fa-align-justify"
  }), _vm._v("Total COD Delivered Shipment - Count")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "20%"
    }
  }, [_c('b', [_vm._v("Type")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "15%"
    }
  }, [_c('b', [_vm._v("Single")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "15%"
    }
  }, [_c('b', [_vm._v("Hybrid")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "30%"
    }
  }, [_c('b', [_vm._v("Amount ( "), _c('i', {
    staticClass: "fa fa-rupee"
  }), _vm._v(" )")])])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "fa fa-align-justify"
  }), _vm._v("COD Amount")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Result")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("#")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Delivery Date ")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("COD Receivable ( "), _c('i', {
    staticClass: "fa fa-rupee"
  }), _vm._v(" )")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Paid Amount ( "), _c('i', {
    staticClass: "fa fa-rupee"
  }), _vm._v(" )")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Pending Amount ( "), _c('i', {
    staticClass: "fa fa-rupee"
  }), _vm._v(" )")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Created Date")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Created By")])])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f5bbbd7","hasScoped":true}!./src/views/components/srclosure/srclosure.component.html
// module id = 385
// module chunks = 1